export default {
  namespaced: true,

  state: {
    baseElement: null,
    originCanvas: null,
    canvasIframe: null,
    visible: false,
    color: null
  },

  mutations: {
    toggle(state, { flag, dom, canvas, canvasIframe }) {
      state.visible = flag
      if (dom !== undefined) state.baseElement = dom
      if (canvas !== undefined) state.originCanvas = canvas
      if (canvasIframe !== undefined) state.canvasIframe = canvasIframe
    },
    setCanvas(state, { dom, canvas, canvasIframe }) {
      if (dom !== undefined) state.baseElement = dom
      if (canvas !== undefined) state.originCanvas = canvas
      if (canvasIframe !== undefined) state.canvasIframe = canvasIframe
    },
    setColor(state, color) {
      state.color = color
    }
    // setBaseElement(state, dom) {
    //   state.baseElement = dom
    // },
    // setOriginCanvas(state, canvas) {
    //   state.originCanvas = canvas
    // }
  },

  actions: {

  }
}
